/* Components */
import Icon from 'Components/Icon';

/* Style */
import './style.scss';

const Checkbox = ({ action, choice }) => (
	<div className="checkbox-component">
		<input type="checkbox" checked={choice.value} onChange={() => null} />
		<div className="checkbox-wrapper" onClick={action} role="button" tabIndex={0}>
			<div className="box">
				<Icon name="utilitary_check" isHM label="Sélectionner la commande" position="right" />
			</div>
			{ choice.label && (
				<div className="text">
					<span>{choice.label}</span>
				</div>
			)}
		</div>
	</div>
);

Checkbox.propTypes = {
	action: PropTypes.func.isRequired,
	choice: PropTypes.shape({
		value: PropTypes.bool,
		label: PropTypes.string
	}).isRequired
};


export default Checkbox;
